import type { SidebarNavRowStatus } from './sidebar-nav-row-status.types';

/** One left-slot icon per row — highest-priority active state wins. */
export function resolveChatSidebarNavRowStatus({
  isStreaming,
  needsAttention,
  hasDraft,
  isCurrentChat,
}: {
  isStreaming: boolean;
  needsAttention: boolean;
  hasDraft: boolean;
  isCurrentChat: boolean;
}): SidebarNavRowStatus {
  if (needsAttention) return 'needs-attention';
  if (isStreaming) return 'streaming';
  if (hasDraft && !isCurrentChat) return 'draft';
  return 'rest';
}
